// require ('promise-polyfill');
import 'promise-polyfill';
import 'whatwg-fetch';

import splashVideo from './modules/splashVideo';
import SwiperSlider from './modules/swiperSlider';
import enableTabbing from './modules/enableTabbing';
import talksFilters from './modules/talksFilters';
import validInputs from './modules/validInputs';
import siteSearch from './modules/siteSearch';
import talkVideoControls from './modules/talkVideoControls';

splashVideo();
// eslint-disable-next-line no-unused-vars
const previousTalks = new SwiperSlider(document.querySelector('#previousTalks .swiper-container'));
// eslint-disable-next-line no-unused-vars
const seasonSelect = new SwiperSlider(document.querySelector('#seasonSelect .swiper-container'));
// eslint-disable-next-line no-unused-vars
const panelBlock = new SwiperSlider(document.querySelector('#panelBlock .swiper-container'));
enableTabbing();
talksFilters();
validInputs();
siteSearch();
talkVideoControls();

// Get the viewport height and multiply it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then set the custom --vh value to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);

// We listen to the resize event
window.addEventListener('resize', () => {
    // Update the element's size
    vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
});
